export default function ShopIcon({ className }: any) {
  return (
    <svg className={className} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 11.2712C4 9.83296 4 9.11384 4.29407 8.48173C4.58813 7.84962 5.14039 7.38163 6.24491 6.44564L7.31634 5.53769C9.31275 3.8459 10.311 3 11.5 3C12.689 3 13.6872 3.8459 15.6837 5.53769L16.7551 6.44564C17.8596 7.38163 18.4119 7.84962 18.7059 8.48173C19 9.11384 19 9.83296 19 11.2712V15.7629C19 17.7603 19 18.759 18.3724 19.3795C17.7447 20 16.7346 20 14.7143 20H8.28571C6.26541 20 5.25526 20 4.62763 19.3795C4 18.759 4 17.7603 4 15.7629V11.2712Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M14 20V13C14 12.4477 13.5523 12 13 12H10C9.44772 12 9 12.4477 9 13V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
